var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "flex-grow-1"
  }, [_vm.showForm ? _c('dialog-scroll-lock', {
    attrs: {
      "width": "500",
      "persistent": "",
      "fullscreen": _vm.$vuetify.breakpoint.xsOnly
    },
    model: {
      value: _vm.showForm,
      callback: function ($$v) {
        _vm.showForm = $$v;
      },
      expression: "showForm"
    }
  }, [_c('form-builder', {
    on: {
      "close": function ($event) {
        _vm.showForm = false;
      }
    },
    model: {
      value: _vm.order.event.form,
      callback: function ($$v) {
        _vm.$set(_vm.order.event, "form", $$v);
      },
      expression: "order.event.form"
    }
  })], 1) : _vm._e(), _vm.showGuestList ? _c('public-guest-list-dialog', {
    attrs: {
      "form": _vm.order.event.form,
      "guests": _vm.guests
    },
    model: {
      value: _vm.showGuestList,
      callback: function ($$v) {
        _vm.showGuestList = $$v;
      },
      expression: "showGuestList"
    }
  }) : _vm._e(), _vm.showAddToCalendar ? _c('add-to-calendar-dialog', {
    attrs: {
      "event": _vm.order.event
    },
    model: {
      value: _vm.showAddToCalendar,
      callback: function ($$v) {
        _vm.showAddToCalendar = $$v;
      },
      expression: "showAddToCalendar"
    }
  }) : _vm._e(), _c('div', {
    staticClass: "fill-height overflow-auto relative opts-container",
    class: {
      'hide-preview': _vm.hidePreview
    }
  }, [_c('title-toggle', {
    ref: "details",
    attrs: {
      "title": "Event name / details",
      "icon": _vm.mdiTextShort,
      "error": _vm.errors.name || _vm.errors.details
    },
    model: {
      value: _vm.show,
      callback: function ($$v) {
        _vm.show = $$v;
      },
      expression: "show"
    }
  }, [_c('v-textarea', {
    staticClass: "white inline-error",
    attrs: {
      "outlined": "",
      "auto-grow": "",
      "rows": "1",
      "persistent-placeholder": "",
      "label": "Event name *",
      "disabled": _vm.isCancelled,
      "rules": _vm.buildRules({
        required: true,
        limit: 100
      })
    },
    on: {
      "update:error": function (v) {
        return _vm.errors.name = v;
      }
    },
    model: {
      value: _vm.order.event.name,
      callback: function ($$v) {
        _vm.$set(_vm.order.event, "name", $$v);
      },
      expression: "order.event.name"
    }
  }), _c('v-textarea', {
    staticClass: "mt-4 white inline-error",
    attrs: {
      "outlined": "",
      "auto-grow": "",
      "rows": "3",
      "placeholder": "",
      "persistent-placeholder": "",
      "label": "Details",
      "disabled": _vm.isCancelled,
      "rules": _vm.buildRules({
        limit: 500
      })
    },
    on: {
      "update:error": function (v) {
        return _vm.errors.details = v;
      }
    },
    model: {
      value: _vm.order.event.details,
      callback: function ($$v) {
        _vm.$set(_vm.order.event, "details", $$v);
      },
      expression: "order.event.details"
    }
  })], 1), _c('title-toggle', {
    ref: "time-place",
    attrs: {
      "title": "Time / place",
      "icon": _vm.mdiMapClock,
      "error": _vm.errors.time || _vm.errors.place
    },
    model: {
      value: _vm.show,
      callback: function ($$v) {
        _vm.show = $$v;
      },
      expression: "show"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-wrap ma-n2"
  }, [_c('input-date', {
    staticClass: "ma-2",
    attrs: {
      "label": `Date${_vm.isRequired('date_start') ? ' *' : ''}`,
      "clearable": !_vm.isRequired('date_start') || _vm.order.state == 'PENDING',
      "disabled": _vm.isCancelled,
      "rules": _vm.isRequired('date_start') ? [function (v) {
        return !!v || 'Required';
      }] : []
    },
    model: {
      value: _vm.order.event.date_start,
      callback: function ($$v) {
        _vm.$set(_vm.order.event, "date_start", $$v);
      },
      expression: "order.event.date_start"
    }
  }), _c('div', {
    staticClass: "flex-grow-1 d-flex"
  }, [_c('input-time', {
    staticClass: "ma-2 flex-grow-1",
    attrs: {
      "label": `Start time${_vm.isRequired('time_start') ? ' *' : ''}`,
      "disabled": _vm.isCancelled,
      "rules": _vm.isRequired('time_start') ? [function (v) {
        return !!v || 'Required';
      }] : []
    },
    model: {
      value: _vm.order.event.time_start,
      callback: function ($$v) {
        _vm.$set(_vm.order.event, "time_start", $$v);
      },
      expression: "order.event.time_start"
    }
  }), _c('input-time', {
    staticClass: "ma-2 flex-grow-1",
    attrs: {
      "label": "End time",
      "disabled": _vm.isCancelled,
      "hint": _vm.order.event.time_end && _vm.order.event.time_end <= _vm.order.event.time_start ? '+1 day' : null
    },
    model: {
      value: _vm.order.event.time_end,
      callback: function ($$v) {
        _vm.$set(_vm.order.event, "time_end", $$v);
      },
      expression: "order.event.time_end"
    }
  })], 1)], 1), _c('input-timezone', {
    attrs: {
      "disabled": _vm.isCancelled,
      "datetime": _vm.order.event.from ? new Date(_vm.order.event.from) : _vm.order.event.date_start ? new Date(_vm.order.event.date_start + 'T00:00:00') : null
    },
    model: {
      value: _vm.order.event.tz,
      callback: function ($$v) {
        _vm.$set(_vm.order.event, "tz", $$v);
      },
      expression: "order.event.tz"
    }
  }), _c('event-location-form', {
    staticClass: "mt-n1",
    attrs: {
      "required": _vm.isRequired('location'),
      "disabled": _vm.isCancelled,
      "event": _vm.order.event
    }
  })], 1), !_vm.hideRsvpOptions ? _c('title-toggle', {
    ref: "rsvp",
    attrs: {
      "title": "RSVP options",
      "icon": _vm.mdiTextBoxCheck,
      "error": _vm.errors.rsvp
    },
    model: {
      value: _vm.show,
      callback: function ($$v) {
        _vm.show = $$v;
      },
      expression: "show"
    }
  }, [_c('v-select', {
    staticClass: "white d-block",
    staticStyle: {
      "width": "432px",
      "max-width": "100%"
    },
    attrs: {
      "dense": "",
      "outlined": "",
      "hide-details": "",
      "label": "Allow responses from",
      "prepend-inner-icon": _vm.RESPONSE_OPTIONS.find(function (x) {
        return x.value == (_vm.isCancelled ? 'NONE' : _vm.order.event.allowed || 'UNINVITED');
      }).icon,
      "disabled": _vm.isCancelled,
      "items": _vm.RESPONSE_OPTIONS,
      "value": _vm.isCancelled ? 'NONE' : _vm.order.event.allowed || 'UNINVITED'
    },
    on: {
      "input": function (v) {
        return _vm.$set(_vm.order.event, 'allowed', v);
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (_ref) {
        var item = _ref.item;
        return [_c('div', {
          staticClass: "d-flex align-center py-2",
          staticStyle: {
            "max-width": "100%"
          }
        }, [_c('v-icon', {
          staticClass: "mr-3",
          domProps: {
            "innerHTML": _vm._s(item.icon)
          }
        }), _c('div', [_c('div', {
          staticStyle: {
            "line-height": "1.2em"
          },
          domProps: {
            "textContent": _vm._s(item.text)
          }
        }), _c('div', {
          staticClass: "text--label-active",
          domProps: {
            "textContent": _vm._s(item.details)
          }
        })])], 1)];
      }
    }], null, false, 3500234790)
  }), _c('v-checkbox', {
    staticClass: "mt-4 pt-0",
    attrs: {
      "label": "Notify me when people RSVP",
      "hide-details": "",
      "disabled": _vm.isCancelled || _vm.order.event.allowed == 'NONE',
      "input-value": _vm.order.event.rsvp_notify && _vm.order.event.allowed != 'NONE'
    },
    on: {
      "change": function (v) {
        return _vm.$set(_vm.order.event, 'rsvp_notify', v);
      }
    }
  }), _c('v-checkbox', {
    staticClass: "mt-4 pt-0",
    attrs: {
      "label": "Verify guest contact information",
      "hide-details": "",
      "disabled": _vm.isCancelled
    },
    model: {
      value: _vm.order.event.verify,
      callback: function ($$v) {
        _vm.$set(_vm.order.event, "verify", $$v);
      },
      expression: "order.event.verify"
    }
  }), _c('div', {
    staticClass: "ml-8 text--label-active"
  }, [_vm._v("Prevents guests from replying using someone else's email address")]), _c('v-checkbox', {
    staticClass: "mt-4 pt-0",
    attrs: {
      "label": "Make guest list public",
      "hide-details": ""
    },
    model: {
      value: _vm.order.event.public_guest_list,
      callback: function ($$v) {
        _vm.$set(_vm.order.event, "public_guest_list", $$v);
      },
      expression: "order.event.public_guest_list"
    }
  }), _c('div', {
    staticClass: "ml-8 text--label-active"
  }, [_vm._v("Email addresses and phone numbers are never visible to other guests")]), _c('v-expand-transition', [_vm.order.event.public_guest_list ? _c('div', [_c('v-radio-group', {
    staticClass: "pl-8 mt-2 pb-1",
    attrs: {
      "hide-details": ""
    },
    model: {
      value: _vm.order.event.public_guest_list_mode,
      callback: function ($$v) {
        _vm.$set(_vm.order.event, "public_guest_list_mode", $$v);
      },
      expression: "order.event.public_guest_list_mode"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Show all invited guests",
      "value": "ALL"
    }
  }), _c('v-radio', {
    attrs: {
      "label": "Only show guests who responded",
      "value": "ALL_RSVP"
    }
  }), _c('v-radio', {
    attrs: {
      "label": "Only show guests who can make it",
      "value": "ALL_RSVP_ATTENDING"
    }
  })], 1)], 1) : _vm._e()]), _vm.formRoot ? [_c('v-checkbox', {
    staticClass: "mt-4 pt-0",
    attrs: {
      "label": "Limit RSVP party size",
      "hide-details": "",
      "disabled": _vm.isCancelled,
      "input-value": _vm.order.event.form.n_rsvp < 100
    },
    on: {
      "change": function (v) {
        return _vm.order.event.form.n_rsvp = v ? 1 : 100;
      }
    }
  }), _c('div', {
    staticClass: "ml-8 text--label-active"
  }, [_vm._v("You can also adjust this property for individual "), _c(_vm.hidePreview ? 'span' : 'router-link', {
    tag: "component",
    attrs: {
      "to": {
        hash: '#delivery'
      }
    }
  }, [_vm._v("invited guests")])], 1), _vm.order.event.form.n_rsvp != 100 ? _c('int-field', {
    staticClass: "mt-2 ml-8",
    attrs: {
      "disabled": _vm.isCancelled,
      "min": 1,
      "max": 99,
      "value": _vm.order.event.form.n_rsvp
    },
    on: {
      "input": function (v) {
        if (v != 100) _vm.order.event.form.n_rsvp = v;
      }
    }
  }) : _vm._e(), _c('v-checkbox', {
    staticClass: "mt-4 pt-0",
    attrs: {
      "label": "Request separate counts of adults / children",
      "hide-details": "",
      "disabled": _vm.isCancelled
    },
    model: {
      value: _vm.order.event.form.separate_counts,
      callback: function ($$v) {
        _vm.$set(_vm.order.event.form, "separate_counts", $$v);
      },
      expression: "order.event.form.separate_counts"
    }
  }), _c('v-checkbox', {
    staticClass: "mt-4 pt-0",
    attrs: {
      "label": "Request names of individual attendees",
      "hide-details": "",
      "disabled": _vm.isCancelled
    },
    model: {
      value: _vm.order.event.form.request_names,
      callback: function ($$v) {
        _vm.$set(_vm.order.event.form, "request_names", $$v);
      },
      expression: "order.event.form.request_names"
    }
  })] : _vm._e(), _c('v-btn', {
    staticStyle: {
      "margin": "10px 0 -6px -16px"
    },
    attrs: {
      "text": "",
      "color": "primary",
      "disabled": _vm.isCancelled
    },
    on: {
      "click": function ($event) {
        _vm.showForm = true;
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiTextBoxEdit)
    }
  }), _c('span', {
    staticClass: "ml-1 v-label",
    staticStyle: {
      "text-transform": "none",
      "letter-spacing": "normal"
    }
  }, [_vm._v(" Customize RSVP form… ")])], 1)], 2) : _vm._e(), _vm.$vuetify.breakpoint.mdAndDown && !_vm.hidePreview ? _c('div', {
    staticStyle: {
      "height": "48px"
    }
  }) : _vm._e()], 1), !_vm.hidePreview ? _c('div', {
    staticClass: "elevation-20 absolute preview-container",
    class: {
      expanded: _vm.showPreview
    }
  }, [_c('v-btn', {
    staticClass: "hidden-lg-and-up elevation-20 absolute grey lighten-4 pa-6",
    staticStyle: {
      "right": "0",
      "bottom": "100%",
      "outline": "thin solid rgba(0, 0, 0, 0.12)"
    },
    attrs: {
      "text": "",
      "tile": "",
      "color": "ec-dark-blue"
    },
    on: {
      "click": function ($event) {
        _vm.showPreview = !_vm.showPreview;
      }
    }
  }, [_c('v-icon', {
    staticClass: "ml-n1 mr-2",
    style: {
      transform: _vm.showPreview ? 'rotate(180deg)' : null
    },
    attrs: {
      "small": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiArrowCollapseUp)
    }
  }), _vm._v(" Preview RSVP form ")], 1), _c('div', {
    staticClass: "absolute-fill overflow-auto grey lighten-3",
    staticStyle: {
      "z-index": "1"
    }
  }, [_c('v-btn', {
    directives: [{
      name: "blur",
      rawName: "v-blur"
    }],
    staticClass: "mt-5 mb-7 mx-3",
    attrs: {
      "small": "",
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('preview');
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "small": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiAccountEye)
    }
  }), _vm._v(" Preview / send test… ")], 1), _c('div', {
    staticClass: "text--label-active text-center"
  }, [_vm._v("RSVP form preview")]), _c('div', {
    staticClass: "pt-4 pb-12 px-4"
  }, [_c('v-form', {
    key: _vm.testResetKey,
    ref: "test-rsvp",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
      }
    }
  }, [_c('v-card', {
    staticClass: "py-5",
    attrs: {
      "tile": ""
    }
  }, [_c('event-summary', {
    staticClass: "px-6",
    attrs: {
      "event": _vm.order.event,
      "totals": {
        'Attending': 11,
        'Adults': 8,
        'Children': 3
      }
    },
    on: {
      "click-calendar": function ($event) {
        _vm.showAddToCalendar = true;
      },
      "click-guest-list": function ($event) {
        _vm.showGuestList = true;
      }
    }
  }), _c('v-divider', {
    staticClass: "mt-5 mb-4"
  }), _c('div', {
    staticClass: "px-6"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Respond as")]), _c('v-text-field', {
    staticClass: "mt-1",
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "placeholder": "Name",
      "rules": [function (v) {
        return !!v;
      }]
    }
  }), _c('email-phone-field', {
    staticClass: "mt-3",
    attrs: {
      "required": "",
      "hide-contacts": ""
    }
  })], 1)], 1), _c('v-card', {
    staticClass: "mt-4 py-5 px-6",
    attrs: {
      "tile": ""
    }
  }, [_c('form-rsvp', {
    staticClass: "mt-n9",
    attrs: {
      "form": _vm.order.event.form,
      "response": _vm.testResponse
    }
  })], 1)], 1), _c('div', {
    staticClass: "text-center mt-3"
  }, [_c('v-btn', {
    staticClass: "mx-3",
    attrs: {
      "icon": "",
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        _vm.testResetKey = !_vm.testResetKey;
        _vm.testResponse = _vm.patchResponse(_vm.order.event.form, {});
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiRefresh)
    }
  }), _c('span', {
    staticClass: "btn-tooltip bottom"
  }, [_vm._v("Reset")])], 1), _c('v-btn', {
    staticClass: "mx-3",
    attrs: {
      "icon": "",
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        _vm.$confirm(Object.assign({}, _vm.$refs['test-rsvp'].validate() ? {
          title: 'No errors found',
          msg: 'Guests will be able to submit this response as is'
        } : {
          title: 'Errors found',
          msg: 'Guests will have to fix the highlighted sections before submitting a response'
        }, {
          buttons: ['Ok'],
          primary: 'Ok'
        }));
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiCheck)
    }
  }), _c('span', {
    staticClass: "btn-tooltip bottom"
  }, [_vm._v("Test validation")])], 1), _c('v-btn', {
    staticClass: "mx-3",
    attrs: {
      "icon": "",
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        _vm.showForm = true;
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiPencil)
    }
  }), _c('span', {
    staticClass: "btn-tooltip bottom"
  }, [_vm._v("Customize RSVP form")])], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }